<template>
<div>
    <section class="page-title" style="background-color:#c7eafb;">
    <div class="center">
      <v-layout row wrap>
        <v-flex xs12 sm12 lg8>
        <p class="label-planos">Convênio Plano Odontológico</p>
        <h1 class="the-title">Parceria</h1>   
        <h1 class="the-title" style="font-size:30px;color:#00358d">SINTACLUNS - RJ</h1>
        </v-flex>  
        
        <v-flex xs12 sm12 lg4 style="text-align: right;" v-if="this.$vuetify.breakpoint.lg">  
            <br>
            <br>
            <br>
             <img src="../Content/images/logoSintacluns.png" width="300">
        </v-flex>
        <v-flex xs12 sm12 lg4 style="text-align: center;" v-else>  
             <img src="../Content/images/logoSintacluns.png" width="180">
        </v-flex>  
        <v-flex xs12 sm6 md6 lg6>
            <br>
            <v-btn
            style="border-radius: 6px;"
            large                
            dark
            @click="openDialog()"
            color="#00358d"
            >Faça agora a adesão
            </v-btn>
        </v-flex>       
        </v-layout>
    </div>
</section>

<section class="page-content center">
    <v-layout row wrap>
        <v-flex xs12 sm12 lg10>
            <img v-if="this.$vuetify.breakpoint.lg" src="../Content/images/sintaclunsValor.png" style="position: absolute;left: 90%;" width="150px">
            <img v-else src="../Content/images/sintaclunsValor.png" width="150px">

            <p class="title-label">Mais uma vantagem para os empresários</p>
            <p>O SINTACLUNS pensando em como o empresário poderia reter maiores talentos em seu negócio e aumentar sua visibilidade entre seus empregados, determinou conforme a Convenção Coletiva de Trabalho 2021/2022, assinada sob o registro no MTE RJ000714/2021, n° de solicitação MR013555/2021, cláusula 26º PLANO DE ASSISTÊNCIA ODONTOLÓGICA, o compromisso das empresas em disponibilizar plano odontológico aos seus funcionários com desconto em contracheque no valor de R$16,00 (dezesseis reais) mensal por pessoa.</p>
            <p>Caso queira, o funcionário poderá incluir seus dependentes, pagando o valor de R$16,00 (dezesseis reais) mensal por pessoa, através de desconto em contracheque. Após análise, recomendamos o plano odontológico da PrimaVida Dental, pois além de oferecer condições diferenciadas facilitando assim o cumprimento da convenção coletiva, também oferece vantagens para o empresário e benefícios aos seus funcionários.</p>
            <p>A PrimaVida Dental é formada por profissionais altamente qualificados com uma diretoria formada por dentistas com mais de 40 anos de experiência, com vasta rede credenciada com destaque para o Rio de Janeiro, distribuídos em locais estratégicos, em diversas especialidades para melhor atender as necessidades dos seus clientes.</p>

            <p class="title-label">Empresário, entenda melhor as vantagens para a sua empresa</p>
            <p>- Rentabilidade: Ter plano odontológico para uma boa saúde bucal, reflete em funcionários satisfeitos e bons resultados nos negócios, por ter clientes felizes pelo bom atendimento;</p>
            <p>- Relação custo-benefício: o valor negociado se adequa a nossa realidade do cenário atual levando um benefício de qualidade com baixo custo, mais acessível se comparado a um produto similar de mercado;</p>
            <p>- Economia de tempo: o funcionário poderá realizar todas as fases do tratamento em um único local, reduzindo assim, a ausência do local de trabalho;</p>
            <p>- Redução de absenteísmo: eliminação de dor de dente através da disponibilidade de tratamento de qualidade.</p>
            <p>- Atendimento personalizado: Centrais de atendimento totalmente personalizadas para cada tipo de público, com destaque para os gestores de RH/DP, inclusive via WhatsApp;</p>
            <p>- Gestão com praticidade: Acesso à movimentações cadastrais, boletos e relatórios gerenciais, ao seu alcance totalmente on-line, 24 horas;</p>
            
            <p class="title-label">Entenda melhor as vantagens para os beneficiários que aderirem ao plano da PrimaVida Dental</p>
            <p>- Liberação on-line do plano de tratamento;</p>
            <p>- Inclusão do Grupo Familiar, com o investimento por vida dos dependentes diretos: Pai ou padastro; Mãe ou Madrasta; Cônjuge ou companheiros; Filhos e enteados;</p>
            <p>- Investimento acessível que proporciona os funcionários terem acesso ao que temos de mais importante, saúde;</p>
            <p>- Acesso a rede credenciada 24 horas totalmente on-line através do site <a href="http://www.primavida.com.br" target="_blank">www.primavida.com.br</a></p>
            <p>- Desconto em medicamentos nas farmácias parceiras &nbsp;<img src="../Content/images/raia.jpg" width="60px"> &nbsp; <img src="../Content/images/drogasil.jpg" width="110px"></p>
            <p>- Centrais de atendimento totalmente personalizadas para cada tipo de público, com destaque para os clientes, inclusive via WhatsApp; </p>
            <p>- Aplicativo para Celular, Tablet, Smartphone, todas as informações de rede credenciada, carteirinha, autorização, na palma da sua mão;</p>
            <p>- Carteirinha totalmente on-line</p>

            <p><strong>- Funcionário: R$ 16,00, com o valor integral descontado em folha de pagamento, sendo 100% pago pelo funcionário.</strong></p>
            <p><strong>- Dependente: R$ 16,00, com o valor integral descontado em folha de pagamento, sendo 100% pago pelo titular.</strong></p>
        </v-flex>

        <v-flex xs12 sm12 lg12>
            <img src="../Content/images/logo.png" width="200">
        </v-flex>

        <v-flex xs12 sm12 lg7>
            <br>
            <p class="title-label">Acesso à rede credenciada</p>
            <p><a href="http://www.primavida.com.br/redecredenciada" target="_blank">http://www.primavida.com.br/redecredenciada</a></p>
        </v-flex>

        <v-flex xs12 sm12 lg12>
            <br>
            <p class="title-label" style="color:#212121;">App PrimaVida Beneficiário</p>    
        </v-flex>
        <v-flex xs5 sm5 lg2>
            <img src="../Content/images/app_android.png" width="120px"><br>
            <a href="https://play.google.com/store/apps/details?id=br.com.primavida.associado" target="_blank"><img src="../Content/images/android.png" width="120px"></a>&nbsp;
        </v-flex>
        <v-flex xs5 sm5 lg2>
            <img src="../Content/images/app_apple.png" width="120px"><br>
            <a href="https://apps.apple.com/br/app/primavida-dental-associado/id1464690839" target="_blank"><img src="../Content/images/apple_stote.png" width="120px" ></a>&nbsp;
        </v-flex>
        <v-flex xs5 sm5 lg2>
            <img src="../Content/images/app_whats.png" width="120px"><br>
            <a href="https://api.whatsapp.com/send?phone=5521971640379" target="_blank"><img src="../Content/images/whatsapp.png" width="120px" ></a>&nbsp;
        </v-flex>
        <v-flex xs5 sm5 lg3>
            <img src="../Content/images/celular.png" width="130px"><br>    
        </v-flex>

        <v-flex xs5 sm5 lg12>
            <table cellpadding="0" cellspacing="0" border="1">
                <tr >
                    <td style="color: #009b9b;">Plano: </td> 
                    <td>&nbsp; SMILE 1000 RJ </td>
                </tr>
                <tr>
                    <td style="color: #009b9b;">Reg ANS nº: </td>
                    <td>&nbsp; 457.689/08-6 </td>
                </tr>
                <tr>
                    <td style="color: #009b9b;">Tipo de Contratação: </td>
                    <td>&nbsp; COLETIVO EMPRESARIAL </td>
                </tr>
                <tr>
                    <td style="color: #009b9b;">Formação de Preço: </td>
                    <td>&nbsp; PRÉ-ESTABELECIDO </td>
                </tr>
                <tr>
                    <td style="color: #009b9b;">Área de Abrangênia/Atuação: </td>
                    <td>&nbsp; GRUPO DE MUNICÍPIOS RJ </td>
                </tr>
                <tr>
                    <td style="color: #009b9b;">Segmetação Assistencial: </td>
                    <td>&nbsp; EXCLUSIVAMENTE ODONTOLÓGICA </td>
                </tr>
                <tr>
                    <td style="color: #009b9b;">Carência: </td>
                    <td>&nbsp; SEM CARÊNCIA </td>
                </tr>
            </table>
        </v-flex>
    </v-layout>
    <br>
    <p class="title-label">Principais Coberturas (Rol da ANS)</p>
    <div class="icone consultas">
        <span class="icon"></span>
        <p><strong>Consultas</strong> - Consultas iniciais para o plano de tratamento;</p>
    </div>
    <div class="icone urgencia">
        <span class="icon"></span>
        <p><strong>Urgência</strong> - Diversos procedimentos de urgência odontológica;</p>
    </div>
    <div class="icone cirurgia">
        <span class="icon"></span>
        <p><strong>Cirurgia</strong> - Cirurgias odontológicas de pequeno porte realizada em consultórios;</p>
    </div>
    <div class="icone dentistica">
        <span class="icon"></span>
        <p><strong>Dentística</strong> - Restaurações e obturações em material estético (Resina) e amálgama;</p>
    </div>
    <div class="icone endodontia">
        <span class="icon"></span>
        <p><strong>Endodontia</strong> - Tratamento de canais;</p>
    </div>
    <div class="icone periodontia">
        <span class="icon"></span>
        <p><strong>Periodontia</strong> - Tratamento de gengivas;</p>
    </div>
    <div class="icone odontopediatria">
        <span class="icon"></span>
        <p><strong>Odontopediatria</strong> - Atendimento especializado para crianças;</p>
    </div>
    <div class="icone radiologia">
        <span class="icon"></span>
        <p><strong>Raio X</strong> - Periapical, interproximal (bite-wing), oclusal, periapical completa (levantamento radiográfico) e panorâmica;</p>
    </div>
    <div class="icone protese">
        <span class="icon"></span>
        <p><strong>Próteses</strong> - Coroa provisória, Restauração, Coroa, Núcleo e Bloco metálico para dentes permanentes posteriores, Coroa em Cerômero para dentes permanentes anteriores (Entende-se como dentes permanentes anteriores, os dentes definitivos da frente, que correspondem do canino a canino);</p>
    </div>
    <div class="icone profilaxia">
        <span class="icon"></span>
        <p><strong>Prevenção</strong> - Profilaxia / Aplicação de Flúor;</p>
    </div>
    <div class="icone exodontia">
        <span class="icon"></span>
        <p><strong>Exodontia</strong> - Extração, inclusive de siso incluso;</p>
    </div>
    <div>
        <p>Para acessar a cobertura do Rol da ANS, favor <a href="http://www.primavida.com.br/emkt/rol_procedimentos.pdf" target="_blank">clique aqui.</a></p>
        <br>
        <p>Ficha de Adesão, <a href="https://ecommerce.primavida.com.br/contratos/FICHA_DE_ADESAO_COLETIVO_POR_ADESAO_F.A.0321.pdf" target="_blank">clique aqui.</a></p>
        <br>
        <p>A adesão é feita de forma bem simples e totalmente digital. Basta clicar no botão abaixo, preencher todos os dados e anexar os documentos necessários. Em até 72 horas úteis, receberá no e-mail cadastrado, login e senha de primeiro acesso personalizado.</p>
    </div>
    <v-flex xs12 sm6 md6 lg12 >
        <v-btn
        style="border-radius: 6px;"
        large                
        dark
        @click="openDialog()"
        color="#00358d"
        >Faça agora a adesão</v-btn>
        <img src="../Content/images/logo-ans.png" width="200" style="float:right;">
    </v-flex>
</section>
<v-dialog v-model="dialog" max-width="700px" max-height="400px"> 
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total">Prezado(a) parceiro(a),</span>              
              </v-card-title>
              <v-container                    
                    fluid
                    pa-1
                    justify-center
                    class="resumo"
                  >
              <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a  segurança e a tranquilidade que você precisa.</p>
              <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
              <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
              <br>
              <p class="resumo" style="font-weight: bold">A <span style="color:#009B99">PrimaVida Dental</span> agradece a sua atenção !</p>
              <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!!!</p>
              <br>
              <p class="resumo" style="font-weight: bold;color:#009B99">Termo de Privacidade, <a href="https://ecommerce.primavida.com.br/contratos/Politica_de_Privacidade_PrimaVida_LGPD.pdf" target="_blank">clique aqui.</a></p>
              
              <v-checkbox
                    v-model="contrataccept"
                    color="#009B99"
                >
                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da PrimaVida Dental.</span>
          </v-checkbox>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
                  <br>
              <v-btn :disabled="!contrataccept" color="#009b9b" depressed style="border-radius: 8px; width: 130px;color: white;" :href="'https://ecommerce.primavida.com.br/contratopj?plano=60f6cb8a5d8bd404bb665b25'">Continuar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>
<Snackbar ref=chamaSnackbar />
</div>
</template>
<script>
import Snackbar from '../components/snackbar.vue'
export default {
    components: {Snackbar},
     data(){
        return{   
                contrataccept: false,
                dialog: false,
                matricula: '',
                dictionary: {          
                custom: {               
                carteirinha: {
                  required: () => 'Informe o número da carteirinha'
                } 
                }
                }
        }               
    },

    mounted : function(){
        this.$store.dispatch('EscondeToolbar')
        this.$store.dispatch('EscondeFooter')
        this.$validator.localize('pt', this.dictionary)
        localStorage.clear()
        sessionStorage.clear()

    },
     watch: {
        dialog(val) {
        val || this.close()
      }
     },
    methods: {
        openDialog(){
            this.dialog = true
        }
        
    }

}
</script>

<style>

    .link{
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }
    .titulo{
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }
    .tabela{
        border-collapse: separate;
        border-spacing: 2;
    }
</style>